// for interns 
"use client"

import { useState, useEffect, useRef } from "react"
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  TextField,
  List,
  ListItem,
  ListItemText,
  Paper,
  useTheme,
  Stack,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import CameraAltIcon from "@mui/icons-material/CameraAlt"
import SearchIcon from "@mui/icons-material/Search"
import useAuthStore from "../../Zustand/Store/useAuthStore"
import { MAIN_URL } from "../../Configurations/Urls"
import Swal from "sweetalert2"
import axios from "axios"
import toast from "react-hot-toast"
import { useLocation, useNavigate } from "react-router-dom"
import { LogOutIcon } from "lucide-react"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import WorkTimeClock from "../../Components/WorkTimeClock/WorkTimeClock"
import { format } from "date-fns";





const StyledContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
  minHeight: "90vh",
  padding: theme.spacing(3, 2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}))

const HeaderSection = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(3),
  color: "text.primary",
}))

const CircleContainer = styled(Box)(({ theme }) => ({
  width: 200,
  height: 200,
  border: "2px solid #4caf50",
  borderRadius: "50%",
  margin: theme.spacing(3, 0),
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
  color: "text.primary",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  overflow: "hidden",
  position: "relative",
  "&:hover": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
  },
}))

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  flexWrap: "wrap",
  justifyContent: "center",
  marginTop: theme.spacing(3),
}))

const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: 80,
  minHeight: 50,
  border: "1px solid #4caf50",
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
  color: "text.primary",
  fontSize: "12px",
  fontWeight: "normal",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#f0f8f0",
  },
}))

const ChangePhotoButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: "10px",
  minHeight: "24px",
  padding: theme.spacing(0.5, 1),
  backgroundColor: "#4caf50",
  color: "white",
  textTransform: "none",
  borderRadius: theme.spacing(1),
  "&:hover": {
    backgroundColor: "#45a049",
  },
}))

const ImageContainer = styled(Box)({
  width: "100%",
  height: "100%",
  position: "relative",
  "&:hover .edit-overlay": {
    opacity: 1,
  },
})

const SearchContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: 400,
  marginBottom: theme.spacing(2),
  position: "relative",
  color: "text.primary",
}))

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
    borderRadius: theme.spacing(1),
    "& fieldset": {
      borderColor: "#4caf50",
    },
    "&:hover fieldset": {
      borderColor: "#45a049",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#4caf50",
    },
  },
  "& .MuiInputLabel-root": {
    color: "text.primary",
    "&.Mui-focused": {
      color: "text.primary",
    },
  },
}))

const SearchResultsContainer = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  zIndex: 1000,
  maxHeight: 200,
  overflowY: "auto",
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
  color: "text.primary",
  border: "1px solid #4caf50",
  borderRadius: theme.spacing(1),
  marginTop: theme.spacing(0.5),
}))

const SearchResultItem = styled(ListItem)(({ theme }) => ({
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
  },
  borderBottom: "1px solid #e0e0e0",
  "&:last-child": {
    borderBottom: "none",
  },
}))

const FaceAuth2 = () => {
  const location = useLocation()
  const item = location.state || {}
  const { userData ,   resetAuth } = useAuthStore()
  const org = userData?.organization

  const { logout } = useAuthStore()

  const organizationPersonIdFromContext = item?.organization_person_id || item?.intern_id

  const [hasPreselectedIntern, setHasPreselectedIntern] = useState(Boolean(item?.organization_person_id || item?.intern_id))

  console.log("item is  ", item)
  console.log("  Current userData:", userData)
  console.log("  Organization data:", org)
  console.log("  Organization name:", item?.organization_name)

  const [currentDateTime, setCurrentDateTime] = useState("")
  const [isCapturing, setIsCapturing] = useState(false)
  const [capturedImage, setCapturedImage] = useState(null)
  const [cameraError, setCameraError] = useState("")
  const [permissionState, setPermissionState] = useState("prompt")
  const navigate = useNavigate()
  const [userData2, setUserData2] = useState({
    name: "Name",
    functionalRole: "Functional Role",
    authorized: false,
    organization_person_id: null,
    intern_id: null, // Keep for backward compatibility
    profileImage: "Profile_Image_Url",
    currentTotal: null,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [isSearching, setIsSearching] = useState(false)
  const [showResults, setShowResults] = useState(false)
  const [organizationData, setOrganizationData] = useState({
    organization_id: item?.organization_id,
    name: item?.organization_name,
  })
  const [clockInTime, setClockInTime] = useState(null)
  const [isClockedIn, setIsClockedIn] = useState(false)
  const [breakStartTime, setBreakStartTime] = useState(null)
  const [isBreakStarted, setIsBreakStarted] = useState(false)
  const [breakEndTime, setBreakEndTime] = useState(null)
  const [isBreakEnded, setIsBreakEnded] = useState(false)
  const [clockOutTime, setClockOutTime] = useState(null)
  const [isClockedOut, setIsClockedOut] = useState(false)
  const [showAttendanceRecord, setShowAttendanceRecord] = useState(false)
  const [selectedIntern, setSelectedIntern] = useState(null)
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState("")


  const [buttonsDisabled, setButtonsDisabled] = useState(false);




  const [allowed, setAllowed] = useState({
    clockin: true,
    breakstart: false,
    breakend: false,
    clockout: false,
  })

  const resetForNextIntern = () => {
    if (!hasPreselectedIntern && !item?.intern_id) {
      setUserData2({
        name: "Name",
        functionalRole: "Functional Role",
        authorized: false,
        intern_id: null,
        profileImage: "Profile_Image_Url",
        currentTotal: null,
      })
      setSearchQuery("")
      setSearchResults([])
      setShowResults(false)
    }

    setClockInTime(null)
    setBreakStartTime(null)
    setBreakEndTime(null)
    setClockOutTime(null)
    setShowAttendanceRecord(false)
    setSelectedIntern(null)
  }

  const resetAttendanceStates = () => {
    setClockInTime(null)
    setBreakStartTime(null)
    setBreakEndTime(null)
    setClockOutTime(null)
    setShowAttendanceRecord(false)
    setSelectedIntern(null)
  }

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("token")

          await axios.get(`${MAIN_URL}/api/auth/logout`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          logout()
          localStorage.removeItem("token")
          Swal.fire("Logged out!", "You have been logged out.", "success")
          resetAuth()
          navigate("/login")
        } catch (error) {
          console.error("Logout failed:", error)
          logout()
          localStorage.removeItem("token")
          navigate("/login")
        }
      }
    })
  }

  const handleBack = () => {
    try {
      navigate(-1)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.error("Navigation failed:", error)
    }
  }

  const canvasRef = useRef(null)
  const streamRef = useRef(null)

  const theme = useTheme()

  const [apiUrl, setApiUrl] = useState(`${MAIN_URL}/api/organizations/${item?.organization_id}/filter-intern`)

  const checkCameraPermission = async () => {
    try {
      const result = await navigator.permissions.query({ name: "camera" })
      setPermissionState(result.state)
      return result.state
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.log("  Permission API not supported, proceeding with getUserMedia")
      return "prompt"
    }
  }

  const captureImageDirectly = async () => {
    try {
      console.log("  Starting direct image capture...")
      setCameraError("")
      setIsCapturing(true)
      setIsLoading(true)

      const permissionStateResult = await checkCameraPermission()
      console.log("  Camera permission state:", permissionStateResult)

      if (permissionStateResult === "denied") {
        setCameraError("Camera access denied. Please enable camera permissions in your browser settings.")
        setIsCapturing(false)
        setIsLoading(false)
        return
      }

      console.log("  Requesting camera access...")
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 320 },
          height: { ideal: 240 },
          facingMode: "user",
        },
      })

      console.log("  Camera access granted, capturing image...")
      streamRef.current = stream

      const video = document.createElement("video")
      video.srcObject = stream
      video.play()

      video.onloadedmetadata = () => {
        const canvas = canvasRef.current
        if (canvas) {
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight
          const context = canvas.getContext("2d")
          context.drawImage(video, 0, 0)

          const imageDataUrl = canvas.toDataURL("image/jpeg", 0.8)
          setCapturedImage(imageDataUrl)

          canvas.toBlob(
            async (blob) => {
              if (blob) {
                await performFaceRecognition(blob)
              }
            },
            "image/jpeg",
            0.8,
          )
        }

        stream.getTracks().forEach((track) => track.stop())
        streamRef.current = null
      }

      setPermissionState("granted")
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.error("  Error accessing camera:", error)

      let errorMessage = ""
      if (error.name === "NotAllowedError") {
        errorMessage = "Camera access denied. Please allow camera permissions and try again."
      } else if (error.name === "NotFoundError") {
        errorMessage = "No camera found. Please ensure your device has a camera connected."
      } else {
        errorMessage = `Camera error: ${error.message || "Unknown error occurred"}`
      }

      setCameraError(errorMessage)
      setIsCapturing(false)
      setIsLoading(false)
      setPermissionState("denied")
    }
  }

  const performFaceRecognition = async (imageBlob) => {
    try {
      console.log("  Starting face recognition...")

      const formData = new FormData()
      formData.append("image", imageBlob, "face.jpg")

      await new Promise((resolve) => setTimeout(resolve, 2000))

      const mockResponse = {
        success: Math.random() > 0.5,
        user: {
          //   name: "John Doe",
          //   functionalRole: "Senior Software Engineer",
          //   id: 12345,
        },
      }

      console.log("  Face recognition result:", mockResponse)

      setUserData2({
        name: mockResponse.user.name,
        functionalRole: mockResponse.user.functionalRole,
        authorized: mockResponse.success,
        organization_person_id: mockResponse.user.organization_person_id || mockResponse.user.id,
        intern_id: mockResponse.user.id, // Keep for backward compatibility
        profileImage: mockResponse.user.profile_image_url,
        currentTotal: mockResponse.user.Total_Worked_Time,
        TotalAttendance: mockResponse?.user?.Today_Attendance,
        TotalBreaks: mockResponse?.user?.Total_Breaks,
        Should_Stop_BreakCal: mockResponse?.user?.Should_Stop_BreakCal,
        Stop_Cal_Work: mockResponse?.user?.Stop_Cal_Work,
      })

      setIsLoading(false)
      setIsCapturing(false)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.error("Face recognition failed:", error)
      setUserData2((prev) => ({ ...prev, authorized: false }))
      setIsLoading(false)
      setIsCapturing(false)
    }
  }

  const handleChangePhoto = (e) => {
    e.stopPropagation()
    console.log("  Changing photo - resetting captured image")
    setCapturedImage(null)
    setCameraError("")
    setUserData2((prev) => ({ ...prev, authorized: false }))
  }

  const handleCameraClick = () => {
    if (!capturedImage) {
      console.log("  Camera clicked - capturing image directly")
      captureImageDirectly()
    }
  }

  const searchInterns = async (query) => {
    if (!query.trim()) {
      setSearchResults([])
      setShowResults(false)
      return
    }

    if (!apiUrl) {
      console.error("  API URL not available yet")
      return
    }

    setIsSearching(true)
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        mode: "cors",
      })

      console.log("  Search response status:", response.status)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`)
      }

      const data = await response.json()
      console.log("  Raw search API response:", data)

      let interns = Array.isArray(data) ? data : data.interns || data.data || []

      if (Array.isArray(interns) && interns.length > 0 && Array.isArray(interns[0])) {
        interns = interns[0]
      }

      console.log("  Total interns from API:", interns.length)

      const filteredInterns = interns.filter((intern) => {
        const internName = (intern.Name || "").toLowerCase()
        const functionalRole = (intern.Functional_Role || "").toLowerCase()

        const internCode = (
          intern.Intern_Code ||
          intern.intern_code ||
          intern.internCode ||
          intern.code ||
          ""
        )
          .toString()
          .toLowerCase()
        const searchTerm = query.toLowerCase().trim()

        console.log("  Checking intern:", {
          id: intern.id || intern.intern_id,
          name: internName,
          functionalRole: functionalRole,
          internCode: internCode,
          originalInternCode: intern.Intern_Code,
          searchTerm: searchTerm,
        })

        const nameMatch = internName.includes(searchTerm)
        const roleMatch = functionalRole.includes(searchTerm)
        const codeMatch = internCode.includes(searchTerm)

        const isMatch = nameMatch || roleMatch || codeMatch

        if (isMatch) {
          console.log("  MATCH FOUND:", {
            intern: intern.Name || intern.name,
            code: intern.Intern_Code,
            matchType: nameMatch ? "name" : roleMatch ? "functionalRole" : "code",
          })
        }

        return isMatch
      })

      console.log("  Filtered interns count:", filteredInterns.length)
      console.log("  Search query was:", query)

      setSearchResults(filteredInterns)
      setShowResults(true)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.error("  Detailed search error:", error)
      setSearchResults([])
      setShowResults(true)
    } finally {
      setIsSearching(false)
    }
  }

  const handleSearchChange = (event) => {
    const value = event.target.value
    setSearchQuery(value)

    const timeoutId = setTimeout(() => {
      searchInterns(value)
    }, 300)

    if (handleSearchChange.timeoutId) {
      clearTimeout(handleSearchChange.timeoutId)
    }
    handleSearchChange.timeoutId = timeoutId
  }

  const handleInternSelect = (intern) => {
    const internName = intern.Name || intern.name
    const internFunctionalRole = intern.Functional_Role || intern.functionalRole || "Intern"
    const organizationPersonId = intern.organization_person_id || intern.id || intern.intern_id || intern.Intern_ID
    const internId = intern.id || intern.intern_id || intern.Intern_ID // Keep for backward compatibility
    const profileImageUrl = intern.profile_image_url || intern.Profile_Image_Url || intern.profileImage
    const currentTotal = intern.Total_Worked_Time
    const TotalAttendance = intern?.Today_Attendance
    const TotalBreaks = intern?.Total_Breaks
    const Should_Stop_BreakCal = intern?.Should_Stop_BreakCal
    const Stop_Cal_Work = intern?.Stop_Cal_Work

    console.log("Selected intern:", intern)
    console.log("Extracted name:", internName)
    console.log("Extracted functionalRole:", internFunctionalRole)
    console.log("Extracted organization_person_id:", organizationPersonId)
    console.log("Extracted profile image:", profileImageUrl)

    setUserData2({
      name: internName,
      functionalRole: internFunctionalRole,
      authorized: false,
      organization_person_id: organizationPersonId,
      intern_id: internId, // Keep for backward compatibility
      profileImage: profileImageUrl,
      currentTotal: currentTotal,
      TotalAttendance: TotalAttendance,
      TotalBreaks: TotalBreaks,
      Should_Stop_BreakCal: Should_Stop_BreakCal,
      Stop_Cal_Work: Stop_Cal_Work,
    })
    setSearchQuery(internName)
    setShowResults(false)
    setSearchResults([])

    setAllowed({
      clockin: Boolean(intern.clockin ?? intern.allowed?.clockin ?? true),
      breakstart: Boolean(intern.breakstart ?? intern.allowed?.breakstart ?? false),
      breakend: Boolean(intern.breakend ?? intern.allowed?.breakend ?? false),
      clockout: Boolean(intern.clockout ?? intern.allowed?.clockout ?? false),
    })
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".search-container")) {
        setShowResults(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const refreshInternStatus = async () => {
    try {
      if (!item?.organization_id) return
      if (!userData2?.organization_person_id && !userData2?.intern_id && !userData2?.intern_code && !userData2?.name) return

      const token = localStorage.getItem("token")
      if (!token) return

      const intern = await fetchFilterInternStatus({
        MAIN_URL,
        organizationId: item?.organization_id,
        token,
        organizationPersonId: userData2.organization_person_id || userData2.intern_id,
        internId: userData2.intern_id,
        internCode: userData2.intern_code,
        name: userData2.name,
      })

      setIsClockedIn(Boolean(intern?.clockin))
      setIsBreakStarted(Boolean(intern?.breakstart))
      setIsBreakEnded(Boolean(intern?.breakend))
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.log("[v0] refreshInternStatus error:", err)
    }
  }

  useEffect(() => {
    if (userData2.name !== "Name" && userData2.name !== "") {
      refreshInternStatus()
    }
  }, [userData2.name, userData2.organization_person_id, userData2.intern_id, item?.organization_id])

  const handleClockIn = async () => {

    setButtonsDisabled(true)
    if (userData2.name === "Name" || userData2.functionalRole === "Functional Role") {
      alert("Please select an intern first")
      return
    }

    const organizationPersonId = userData2.organization_person_id || userData2.intern_id;
    if (!organizationPersonId) {
      alert("Organization Person ID is missing. Please select an intern from the search results.")
      return
    }

    const token = localStorage.getItem("token")
    if (!token) {
      alert("Authentication token is missing. Please login again.")
      return
    }

    try {
      const now = new Date()
      const timestamp = now.toISOString()
      const formData = new FormData()
      const organizationPersonId = userData2.organization_person_id || userData2.intern_id;
      formData.append("organization_person_id", organizationPersonId.toString())
      formData.append("attendance_log_type", "Clock In")
      formData.append("timestamp", timestamp)
      formData.append("date", now.toISOString().split("T")[0])
      formData.append("remarks", ` Created By ${userData?.full_name} --  Application user Id is ${userData?.application_user_id} -- (created on ${format(new Date(), 'yyyy-MM-dd HH:mm:ss')})`)
      const apiEndpoint = `${MAIN_URL}/api/organizations/${item?.organization_id}/intern-time-logs`
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.ok) {
        await response.json().catch(() => null)

        setClockInTime(timestamp)
        setIsClockedIn(true)
        setSelectedIntern(userData2)

        setAllowed({
          clockin: false,
          breakstart: true,
          breakend: false,
          clockout: true,
        })
        await refreshInternStatus()

        setToastMessage("Intern Login Successfully")
        setShowToast(true)
        setTimeout(() => setShowToast(false), 3000)

        resetAttendanceStates()
        window.location.reload();
      } else {
        const text = await response.text().catch(() => "")
        console.error("Clock in failed:", response.status, text)
        alert("Clock in failed. Please try again.")
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }
      console.error("Error during Clock In:", error)
      alert("An error occurred while clocking in. Please try again.")
    }

    finally{
      setButtonsDisabled(false)
    }
  }

  const handleStartBreak = async () => {
    setButtonsDisabled(true)
    const organizationPersonId = userData2?.organization_person_id || userData2?.intern_id;
    if (!organizationPersonId) {
      alert("Please select an intern first")
      return
    }
    const token = localStorage.getItem("token")
    if (!token) {
      alert("Authentication token is missing. Please login again.")
      return
    }
    try {
      const now = new Date()
      const timestamp = now.toISOString()
      const formData = new FormData()
      formData.append("organization_person_id", String(organizationPersonId))
      formData.append("attendance_log_type", "Break Start")
      formData.append("timestamp", timestamp)
      formData.append("date", now.toISOString().split("T")[0])
      formData.append("remarks", ` Created By ${userData?.full_name} --   user Id is ${userData?.application_user_id} -- (created on ${format(new Date(), 'yyyy-MM-dd HH:mm:ss')})`)

      const apiEndpoint = `${MAIN_URL}/api/organizations/${item?.organization_id}/intern-time-logs`
      const res = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${token}` },
      })

      if (!res.ok) {
        const t = await res.text().catch(() => "")
        throw new Error(`Break start failed: ${res.status} ${t}`)
      }

      setIsBreakStarted(true)
      setBreakStartTime(timestamp)

      setAllowed({
        clockin: false,
        breakstart: false,
        breakend: true,
        clockout: true,
      })
      await refreshInternStatus()

      setToastMessage("Break Started Successfully")
      setShowToast(true)
      setTimeout(() => setShowToast(false), 3000)

      resetAttendanceStates()
      window.location.reload();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }

      console.error(err)
      alert("Failed to start break.")
    }

    finally{
      setButtonsDisabled(false)
    }
  }

  const handleEndBreak = async () => {
    setButtonsDisabled(true)
    const organizationPersonId = userData2?.organization_person_id || userData2?.intern_id;
    if (!organizationPersonId) {
      alert("Please select an intern first")
      return
    }
    const token = localStorage.getItem("token")
    if (!token) {
      alert("Authentication token is missing. Please login again.")
      return
    }
    try {
      const now = new Date()
      const timestamp = now.toISOString()
      const formData = new FormData()
      formData.append("organization_person_id", String(organizationPersonId))
      formData.append("attendance_log_type", "Break End")
      formData.append("timestamp", timestamp)
      formData.append("date", now.toISOString().split("T")[0])
      formData.append("remarks", ` Created By ${userData?.full_name} --   user Id is ${userData?.application_user_id} -- (created on ${format(new Date(), 'yyyy-MM-dd HH:mm:ss')})`)

      const apiEndpoint = `${MAIN_URL}/api/organizations/${item?.organization_id}/intern-time-logs`
      const res = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${token}` },
      })

      if (!res.ok) {
        const t = await res.text().catch(() => "")
        throw new Error(`Break end failed: ${res.status} ${t}`)
      }

      setIsBreakEnded(true)
      setBreakEndTime(timestamp)

      setAllowed({
        clockin: false,
        breakstart: true,
        breakend: false,
        clockout: true,
      })
      await refreshInternStatus()

      setToastMessage("Break Ended Successfully")
      setShowToast(true)
      setTimeout(() => setShowToast(false), 3000)

      resetAttendanceStates()
      window.location.reload();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }
      console.error(err)
      alert("Failed to end break.")
    }
    finally{
      setButtonsDisabled(false)
    }
  }

  const handleClockOut = async () => {
    setButtonsDisabled(true)
    const organizationPersonId = userData2?.organization_person_id || userData2?.intern_id;
    if (!organizationPersonId) {
      alert("Please select an intern first")
      return
    }
    const token = localStorage.getItem("token")
    if (!token) {
      alert("Authentication token is missing. Please login again.")
      return
    }
    try {
      const now = new Date()
      const timestamp = now.toISOString()
      const formData = new FormData()
      formData.append("organization_person_id", String(organizationPersonId))
      formData.append("attendance_log_type", "Clock Out")
      formData.append("timestamp", timestamp)
      formData.append("date", now.toISOString().split("T")[0])
      formData.append("remarks", ` Created By ${userData?.full_name} --   user Id is ${userData?.application_user_id} -- (created on ${format(new Date(), 'yyyy-MM-dd HH:mm:ss')})`)

      const apiEndpoint = `${MAIN_URL}/api/organizations/${item?.organization_id}/intern-time-logs`
      const res = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${token}` },
      })

      if (!res.ok) {
        const t = await res.text().catch(() => "")
        throw new Error(`Clock out failed: ${res.status} ${t}`)
      }

      setIsClockedOut(true)
      setClockOutTime(timestamp)

      setAllowed({
        clockin: true,
        breakstart: false,
        breakend: false,
        clockout: false,
      })
      await refreshInternStatus()

      setToastMessage("Intern Clocked Out Successfully")
      setShowToast(true)
      setTimeout(() => setShowToast(false), 3000)

      resetAttendanceStates()

      window.location.reload();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Session Expired!")
        navigate("/login")
        return
      }
      console.error(err)
      alert("Failed to clock out.")
    }
    finally{
      setButtonsDisabled(false)
    }
  }

  useEffect(() => {
    const orgId = item?.organization_id || org?.organization_id
    if (!orgId) return

    const organizationPersonId = item?.organization_person_id || item?.intern_id || organizationPersonIdFromContext;
    if (organizationPersonId) {
      const token = localStorage.getItem("token")
      if (!token) return
      ;(async () => {
        try {
          const intern = await fetchFilterInternStatus({
            MAIN_URL,
            organizationId: orgId,
            token,
            organizationPersonId: organizationPersonId,
            internId: item?.intern_id || organizationPersonIdFromContext,
          })

          if (intern) {
            const internName = intern.Name || intern.name || "Unknown Intern"
            const internFunctionalRole = intern.Functional_Role || intern.functionalRole || "Intern"
            const profileImageUrl =
              intern.profile_image_url || intern.Profile_Image_Url || intern.profileImage || ""
            const organizationPersonId = intern.organization_person_id || intern.id || intern.intern_id || intern.Intern_ID || item?.organization_person_id || item?.intern_id || organizationPersonIdFromContext
            const internId = intern.id || intern.intern_id || intern.Intern_ID || item?.intern_id || organizationPersonIdFromContext

            const currentTotal = intern?.Total_Worked_Time
            const TotalAttendance = intern?.Today_Attendance
            const TotalBreaks = intern?.Total_Breaks
            const Should_Stop_BreakCal = intern?.Should_Stop_BreakCal
            const Stop_Cal_Work = intern?.Stop_Cal_Work

            setUserData2({
              name: internName,
              functionalRole: internFunctionalRole,
              authorized: false,
              organization_person_id: organizationPersonId,
              intern_id: internId, // Keep for backward compatibility
              profileImage: profileImageUrl,
              currentTotal: currentTotal,
              TotalAttendance: TotalAttendance,
              TotalBreaks: TotalBreaks,
              Should_Stop_BreakCal: Should_Stop_BreakCal,
              Stop_Cal_Work: Stop_Cal_Work,
            })
            setHasPreselectedIntern(true)
            setShowResults(false)

            setSearchQuery(internName)

            setAllowed({
              clockin: Boolean(intern.clockin ?? true),
              breakstart: Boolean(intern.breakstart ?? false),
              breakend: Boolean(intern.breakend ?? false),
              clockout: Boolean(intern.clockout ?? false),
            })
          }
        } catch (e) {
          console.log("[v0] auto-fetch intern failed:", e)
        }
      })()
    }
  }, [organizationPersonIdFromContext, item?.organization_id, item?.organization_person_id, item?.intern_id, org?.organization_id])

  useEffect(() => {
    if (org?.organization_id) {
      setOrganizationData({
        organization_id: item?.organization_id,
        name: item?.organization_name || "Loading...",
      })
      setApiUrl(`${MAIN_URL}/api/organizations/${item?.organization_id}/filter-intern`)
    }
  }, [org])

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date()
      const date = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      const time = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      setCurrentDateTime(`${date} | ${time}`)
    }

    updateDateTime()
    const interval = setInterval(updateDateTime, 1000)

    return () => clearInterval(interval)
  }, [])

  console.log("users data 2", userData2)

  return (
    <StyledContainer>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          position: "fixed",
          top: 16,
          right: 16,
          zIndex: 1300,
          flexWrap: "wrap",
          justifyContent: "flex-end",
          "@media (max-width:600px)": {
            position: "static",
            justifyContent: "center",
            mt: 1,
          },
        }}
      >
        <Button
          variant="contained"
          color="error"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            borderRadius: "8px",
            padding: "6px 16px",
            backgroundColor: "blue",
            boxShadow: 2,
            "&:hover": {
              backgroundColor: "#2f71d3ff",
              boxShadow: 3,
            },
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
          }}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="error"
          startIcon={<LogOutIcon />}
          onClick={handleLogout}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            borderRadius: "8px",
            padding: "6px 16px",
            boxShadow: 2,
            "&:hover": {
              backgroundColor: "#d32f2f",
              boxShadow: 3,
            },
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
          }}
        >
          Logout
        </Button>
      </Stack>

      {showToast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#ffffff",
            color: "text.primary",
            padding: "12px 24px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 9999,
            fontSize: "16px",
            fontWeight: "500",
            animation: "slideIn 0.3s ease-out",
          }}
        >
          {toastMessage}
        </div>
      )}

      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>

      <HeaderSection>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
            marginBottom: 1,
          }}
        >
          HR ERP
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            color: "text.secondary",
            marginBottom: 2,
          }}
        >
          <h3>
            {" "}
            <b>{item?.organization_name}</b>
          </h3>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            fontSize: "14px",
            color: "text.primary",
            mb: 3,
          }}
        >
          {currentDateTime}
        </Typography>


{
    userData2?.name == "Name" ? "" : 
    <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <WorkTimeClock
            stop={userData2?.Stop_Cal_Work == true || userData2?.Should_Stop_BreakCal == false}
            heading="Total Work Time"
            currentTotal={userData2?.currentTotal}
          />

          <WorkTimeClock
            stop={userData2?.Should_Stop_BreakCal}
            heading="Total Break Time"
            currentTotal={userData2?.TotalBreaks}
          />
        </div>
}
        
      </HeaderSection>

      {!hasPreselectedIntern && !item?.organization_person_id && !item?.intern_id && (
        <SearchContainer className="search-container">
          <StyledTextField
            fullWidth
            variant="outlined"
            placeholder="Search by intern code..."
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: "#4caf50", marginRight: 1 }} />,
              endAdornment: isSearching && <CircularProgress size={20} sx={{ color: "#4caf50" }} />,
            }}
            size="small"
          />

          {showResults && searchResults?.length > 0 && (
            <SearchResultsContainer elevation={3}>
              <List dense>
                {searchResults?.map((intern, index) => (
                  <SearchResultItem
                    key={intern.id || intern.intern_id || index}
                    onClick={() => handleInternSelect(intern)}
                  >
                    <ListItemText
                      primary={`${intern.Name || intern.name || "Unknown Intern"} (${intern.Intern_Code || intern.intern_code || "No Code"})`}
                      secondary={intern.Functional_Role || intern.functionalRole || "Intern"}
                      primaryTypographyProps={{ fontSize: "14px" }}
                      secondaryTypographyProps={{
                        fontSize: "12px",
                        color: "text.primary",
                      }}
                    />
                  </SearchResultItem>
                ))}
              </List>
            </SearchResultsContainer>
          )}

          {showResults && searchResults.length === 0 && !isSearching && searchQuery.trim() && (
            <SearchResultsContainer elevation={3}>
              <Box sx={{ padding: 2, textAlign: "center" }}>
                <Typography variant="body2" sx={{ color: "text.primary", fontSize: "12px" }}>
                  {'No interns found matching "'}
                  {searchQuery}
                  {'"'}
                </Typography>
              </Box>
            </SearchResultsContainer>
          )}
        </SearchContainer>
      )}

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <CircleContainer onClick={handleCameraClick}>
          {userData2?.profileImage ? (
            <img
              src={userData2.profileImage || "/placeholder.svg"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          ) : (
            <>
              <CameraAltIcon
                sx={{
                  fontSize: 60,
                  color: "#4caf50",
                  marginBottom: 1,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "10px",
                  color: "text.secondary",
                  textAlign: "center",
                  lineHeight: 1.2,
                }}
              >
                Face recognition
              </Typography>
            </>
          )}
        </CircleContainer>

        {capturedImage && !userData2?.profileImage && (
          <ChangePhotoButton onClick={handleChangePhoto}>Change Photo</ChangePhotoButton>
        )}
      </Box>

      {cameraError && (
        <Box
          sx={{
            textAlign: "center",
            marginBottom: 2,
            padding: 2,
            backgroundColor: "#ffebee",
            borderRadius: 1,
          }}
        >
          <Typography variant="body2" sx={{ color: "#f44336", fontSize: "12px" }}>
            {cameraError}
          </Typography>
        </Box>
      )}

      <Box sx={{ textAlign: "center", marginBottom: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "text.primary", marginBottom: 0.5 }}>
          {userData2.name}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {userData2.functionalRole}
        </Typography>
      </Box>

      <ButtonContainer>
        <ActionButton
          variant="outlined"
          onClick={handleClockIn}
          disabled={!allowed.clockin || buttonsDisabled == true}
          sx={{
            opacity: !allowed.clockin ? 0.7 : 1,
            backgroundColor: !allowed.clockin ? theme.palette.background.default : "#ffffff",
            color: !allowed.clockin ? "#2e7d32" : "#333",
            cursor: !allowed.clockin ? "not-allowed" : "pointer",
            "&:hover": {
              backgroundColor: !allowed.clockin ? theme.palette.background.default : "#f0f8f0",
            },
          }}
        >
          Clock
          <br />
          In
          {isClockedIn && (
            <Typography variant="caption" sx={{ fontSize: "8px", display: "block", marginTop: "2px" }}>
              {clockInTime &&
                new Date(clockInTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
            </Typography>
          )}
        </ActionButton>
        <ActionButton
          variant="outlined"
          onClick={handleStartBreak}
          disabled={!allowed.breakstart  || buttonsDisabled == true}
          sx={{
            opacity: !allowed.breakstart ? 0.7 : 1,
            backgroundColor: !allowed.breakstart ? theme.palette.background.default : "white",
            color: !allowed.breakstart ? "#2e7d32" : "#333",
            cursor: !allowed.breakstart ? "not-allowed" : "pointer",
            "&:hover": {
              backgroundColor: !allowed.breakstart ? "#e8f5e8" : "#f0f8f0",
            },
          }}
        >
          Break
          <br />
          Start
          {isBreakStarted && (
            <Typography variant="caption" sx={{ fontSize: "8px", display: "block", marginTop: "2px" }}>
              {breakStartTime &&
                new Date(breakStartTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
            </Typography>
          )}
        </ActionButton>
        <ActionButton
          variant="outlined"
          onClick={handleEndBreak}
          disabled={!allowed.breakend  || buttonsDisabled == true}
          sx={{
            opacity: !allowed.breakend ? 0.7 : 1,
            backgroundColor: !allowed.breakend ? theme.palette.background.default : "white",
            color: !allowed.breakend ? "#2e7d32" : "#333",
            cursor: !allowed.breakend ? "not-allowed" : "pointer",
            "&:hover": {
              backgroundColor: !allowed.breakend ? "#e8f5e8" : "#f0f8f0",
            },
          }}
        >
          Break
          <br />
          End
          {isBreakEnded && (
            <Typography variant="caption" sx={{ fontSize: "8px", display: "block", marginTop: "2px" }}>
              {breakEndTime &&
                new Date(breakEndTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
            </Typography>
          )}
        </ActionButton>
        <ActionButton
          variant="outlined"
          onClick={handleClockOut}
          disabled={!allowed.clockout  || buttonsDisabled == true}
          sx={{
            opacity: !allowed.clockout ? 0.7 : 1,
            backgroundColor: !allowed.clockout ? theme.palette.background.default : "white",
            color: !allowed.clockout ? "#2e7d32" : "#333",
            cursor: !allowed.clockout ? "not-allowed" : "pointer",
            "&:hover": {
              backgroundColor: !allowed.clockout ? "#e8f5e8" : "#f0f8f0",
            },
          }}
        >
          Clock
          <br />
          Out
          {isClockedOut && (
            <Typography variant="caption" sx={{ fontSize: "8px", display: "block", marginTop: "2px" }}>
              {clockOutTime &&
                new Date(clockOutTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
            </Typography>
          )}
        </ActionButton>
      </ButtonContainer>

      <canvas ref={canvasRef} style={{ display: "none" }} />
    </StyledContainer>
  )
}

async function fetchFilterInternStatus(opts) {
  try {
    const { MAIN_URL, organizationId, token, organizationPersonId, internId, internCode, name } = opts
    if (!organizationId) throw new Error("Missing organization id")

    const url = new URL(`${MAIN_URL}/api/organizations/${organizationId}/filter-intern`)
    if (organizationPersonId) url.searchParams.set("organization_person_id", String(organizationPersonId))
    if (internId) url.searchParams.set("intern_id", String(internId))
    if (internCode) url.searchParams.set("intern_code", String(internCode))
    if (name) url.searchParams.set("q", String(name))

    const res = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })

    if (!res.ok) {
      const text = await res.text().catch(() => "")
      throw new Error(`filter-intern failed: ${res.status} ${text}`)
    }

    const data = await res.json()

    let list = []
    if (Array.isArray(data)) {
      list = data
    } else if (Array.isArray(data?.data)) {
      list = data.data
    } else if (Array.isArray(data?.interns)) {
      list = data.interns
    } else if (Array.isArray(data?.[0])) {
      list = data[0]
    } else if (data) {
      list = [data]
    }

    const searchId = organizationPersonId || internId;
    if (searchId && Array.isArray(list)) {
      const targetId = String(searchId)
      const match = list.find((e) => {
        const ids = [e?.organization_person_id, e?.id, e?.intern_id, e?.Intern_ID, e?.InternId]
          .filter((v) => v !== undefined && v !== null)
          .map(String)
        return ids.includes(targetId)
      })
      if (match) return match
    }

    return Array.isArray(list) ? list[0] : list
  } catch (err) {
    if (err.message && err.message.includes("401")) {
      toast.error("Session Expired!")
      window.location.href = "/login"
      return
    }
    if (err.response && err.response.status === 401) {
      toast.error("Session Expired!")
      window.location.href = "/login"
      return
    }
    console.error("Error in fetchFilterInternStatus:", err)
    toast.error(err.message || "Unexpected error occurred")
  }
}

export default FaceAuth2

















